import CaladreTheme from "theme/Theme";
import sharedStyle from "../style";

const classes = {
  ...sharedStyle,
  rechercheVoyage: {
    paddingTop: CaladreTheme.spacing(1.5),
    paddingBottom: CaladreTheme.spacing(1.5),
    "& .MuiGrid-item": {
      padding: CaladreTheme.spacing(0, 1),
      position: "relative",
      cursor: "pointer",
      "&:last-child": {
        cursor: "default",
        padding: CaladreTheme.spacing(0),
        [CaladreTheme.breakpoints.up("lg")]: {
          marginTop: CaladreTheme.spacing(-1.5),
        },
        marginBottom: CaladreTheme.spacing(-1.5),
        backgroundColor: CaladreTheme.palette.primary.main,
        "& button": {
          height: "100%",
          width: "100%",
          border: `1px solid ${CaladreTheme.palette.primary.main} !important`,
          "& .MuiSvgIcon-root ": {
            marginLeft: `${CaladreTheme.spacing(0)} !important`,
            fontSize: "30px !important",
            color: CaladreTheme.custom.White,
            transition: "all 0.2s ease-in-out",
            "&:hover": {
              transform: "scale(1.1)",
            },
          },
        },
      },
      "&:not(:nth-last-of-type(2)):not(:last-child)": {
        borderRight: "solid rgba(0, 43, 96, 0.5)",
        borderRightWidth: "thin",
      },
      "&:not(:last-child)": {
        padding: CaladreTheme.spacing(0, 1),
      },
      "& .MuiTypography-body1": {
        color: CaladreTheme.palette.primary.main,
        [CaladreTheme.breakpoints.down("xl")]: {
          fontSize: "12px",
        },
      },
      "& .MuiList-root": {
        zIndex: 99,
        backgroundColor: CaladreTheme.custom.White,
        padding: CaladreTheme.spacing(2, 0),
        "& .MuiListItemIcon-root": {
          minWidth: "unset",
        },
        "& .MuiTypography-root": {
          fontFamily: "PoppinsSemiBold, sans-serif",
          fontSize: "10px",
          color: CaladreTheme.custom.Black,
        },
        "& .MuiCheckbox-root": {
          padding: CaladreTheme.spacing(0, 1),
        },
        "& .MuiSvgIcon-root": { fontSize: 28 },
      },
    },
  },
  rechercheVoyageMobile: {
    maxWidth: "100%",
    "& .MuiGrid-item": {
      padding: CaladreTheme.spacing(0, 1),
      "& .MuiTypography-body1": {
        color: CaladreTheme.palette.primary.main,
      },
      "& .MuiList-root": {
        zIndex: 99,
        backgroundColor: CaladreTheme.custom.White,
        padding: CaladreTheme.spacing(2, 0),
        "& .MuiListItemIcon-root": {
          minWidth: "unset",
        },
        "& .MuiTypography-root": {
          fontFamily: "PoppinsSemiBold, sans-serif",
          fontSize: "10px",
          color: CaladreTheme.custom.Black,
        },
        "& .MuiCheckbox-root": {
          padding: CaladreTheme.spacing(0, 1),
        },
        "& .MuiSvgIcon-root": { fontSize: 28 },
      },
    },
  },
  rechercheVoyageFields: {
    maxWidth: "100%",
    position: "absolute",
    marginTop: "3px",
    backgroundColor: "transparent",
    "& .MuiListItemText-root": {
      margin: CaladreTheme.spacing(1, 0),
    },
    "& .MuiListItemText-root p": {
      fontFamily: "PoppinsRegular,sans-serif !important",
    },
    "& .MuiGrid-item": {
      position: "relative",
      "& > *": {
        boxShadow: 1,
      },
    },
    "& .MuiList-root": {
      zIndex: 99,
      position: "absolute",
      left: "-20px",
      minWidth: "200px",
      borderRadius: "12px",
      padding: CaladreTheme.spacing(2, 2),
      backgroundColor: CaladreTheme.custom.White,
      "& .MuiListItemIcon-root": {
        minWidth: "unset",
      },
      "& .MuiTypography-root": {
        fontSize: "12px",
        color: CaladreTheme.custom.Black,
      },
      "& .MuiCheckbox-root": {
        padding: CaladreTheme.spacing(0, 2, 0, 0),
      },
      "& .MuiListItemText-secondary": {
        fontSize: "10px",
      },
    },
    "& .rmdp-wrapper": {
      position: "absolute",
      minWidth: "250px",
    },
  },
  searchDestinationBtn: {
    backgroundColor: CaladreTheme.palette.primary.main,
    "& button": {
      border: "none",
      boxShadow: "none",
      width: "100%",
      color: CaladreTheme.custom.White,
      "&:hover": {
        backgroundColor: CaladreTheme.palette.primary.main,
        color: CaladreTheme.custom.White,
        border: "none",
        boxShadow: "none",
      },
      "& .MuiSvgIcon-root ": {
        marginLeft: CaladreTheme.spacing(1),
        fontSize: "16px",
        color: CaladreTheme.custom.White,
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          transform: "scale(1.1)",
        },
      },
    },
  },
  cancelOrValidateBloc: {
    my: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "& .MuiButton-root:first-of-type": {
      color: CaladreTheme.custom.Black,
      textDecoration: "underline",
    },
  },
  homeBloc: {
    width: "100%",
    textAlign: "center",
    padding: CaladreTheme.spacing(4, 0),
    "& .MuiTypography-subtitle2": {
      marginTop: CaladreTheme.spacing(4),
      marginBottom: CaladreTheme.spacing(4),
    },
    "& .MuiGrid-item": {
      "& .MuiBox-root": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100px",
        height: "100px",
        margin: "auto",
        borderRadius: "50%",
        backgroundColor: CaladreTheme.palette.primary.main,
        "& .MuiSvgIcon-root": {
          width: "48px",
          height: "48px",
          color: CaladreTheme.custom.White,
        },
      },
      "& .MuiTypography-h5": {
        marginTop: CaladreTheme.spacing(2),
        marginBottom: CaladreTheme.spacing(2),
      },
    },
    [CaladreTheme.breakpoints.down("lg")]: {
      "& .MuiGrid-item:nth-of-type(2)": {
        my: "16px",
      },
    },
  },
  bgGray: {
    backgroundColor: "#F4F4F4",
  },
  fieldBtnForMobile: {
    fontWeight: "bold",
    color: CaladreTheme.palette.primary.main,
    justifyContent: "start",
    width: "100%",
    margin: CaladreTheme.spacing(0.8, 0),
    padding: CaladreTheme.spacing(1, 1),
    border: "none",
    borderRadius: "12px",
    backgroundColor: CaladreTheme.custom.Gray,
    "&:hover": {
      border: "none",
      color: "black",
      backgroundColor: CaladreTheme.custom.Gray,
    },
    "& .MuiTypography-body1": {
      marginLeft: CaladreTheme.spacing(0.5),
      fontSize: "10px",
    },
  },
  inlineFields: {
    "& .MuiGrid-item": {
      "& button": {
        display: "inline",
      },
      "& p": {
        display: "inline",
      },
    },
  },
};
export default classes;
